<template>
<div style=" padding:20px;margin-top:10px;background: #fff;  ">
 <el-form ref="form" :model="form"  label-width="80px" style="margin: 50px">
  <el-form-item label="旧密码" required>
    <el-input v-model="form.pwd" placeholder="请输入旧密码"  show-password ></el-input>
  </el-form-item>
  <el-form-item label="新密码" required>
    <el-input v-model="form.newpwd1" placeholder="请输入新密码"  show-password > </el-input>
  </el-form-item>
  <el-form-item label="确认密码" required>
    <el-input v-model="form.newpwd2" placeholder="请确认新密码"  show-password ></el-input>
  </el-form-item>
   
 
  <el-form-item>
    <el-button type="primary" :loading="is_loading" @click="onSubmit" >保存</el-button>
    
	
  </el-form-item>
</el-form>
</div>
</template>
 
<script>
export default {
    data() {
      return {
	    is_loading: false,
		loading: true,
        form: {
          pwd: '',
		  newpwd1: '',
		  newpwd2: '',
		  
        }
      }
    },

    methods: { 
	  
      onSubmit() { 
	    let that = this;
	    let userInfo = localStorage.getItem('userInfo');
		let info = JSON.parse(userInfo);
		let id = info.id; 
		
		if (that.form.pwd == '' || that.form.newpwd1 == ''){ 
			this.$message({
                  message: '不能为空！',
                  type: 'warning'
                  });
		    return;
		    }
		
		if (that.form.newpwd1 != that.form.newpwd2){ 
			this.$message({
                  message: '新密码不一致！',
                  type: 'error'
                  });
		    return;
		    }
			
	  	that.is_loading = true; 
		  $.ajax({
              type: "POST",
			  data: {id: info.id, 
			      old_password: that.form.pwd, 
				  new_password: that.form.newpwd1, 
				  } ,
              url: "https://www.myferp.com/admin/user/pwdChange",
              dataType: "json",  //返回类型为 json
              beforeSend: function (request) {
                request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
                },   
              error: function(XMLHttpRequest, textStatus, errorThrown) { 
 		          that.is_loading = false;
			      this.$message({
                    message: data,
                    type: 'error'
                    });
                        return false;
                    },             
              success: function (data) {
		        that.is_loading = false;
				console.log(JSON.stringify(data));
				if (data.errno != 0){
			    	this.$message({
                     message: data.errmsg,
                     type: 'error'
                     });
				  }
				else{
			    	this.$message({
                     message: data,
                     type: 'success'
                     });
                  }
				}
              });	
			 
			     
      }
    },
    mounted() {
	   
	},
  }
</script>
 
 


// WEBPACK FOOTER //
// src/components/setting/changePwd.vue